export default "__VITE_ASSET__DoRH28Dd__"